__turbopack_context__.v({
  "bottom": "fade-in-animation-module-sass-module__Q84Kza__bottom",
  "height": "fade-in-animation-module-sass-module__Q84Kza__height",
  "left": "fade-in-animation-module-sass-module__Q84Kza__left",
  "modalBaseAnimate": "fade-in-animation-module-sass-module__Q84Kza__modalBaseAnimate",
  "not-visible": "fade-in-animation-module-sass-module__Q84Kza__not-visible",
  "opacity": "fade-in-animation-module-sass-module__Q84Kza__opacity",
  "right": "fade-in-animation-module-sass-module__Q84Kza__right",
  "visible": "fade-in-animation-module-sass-module__Q84Kza__visible",
});
